module.exports = new __parcel__URL__("global-issue-navigator-header-skeleton.tpl.f1ae7ec6.svg").toString();